import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './vuex/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/iconfont/iconfont.css'
import '../src/assets/iconfont/iconfont.js'

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
Vue.use(ElementUI)

//照片旋转
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Viewer, {
    defaultOptions: {
        zIndex: 9999,
        title: false, //    显示当前图片的标题
        scalable: false, //图片是否可翻转
        rotatable: true, //图片是否可旋转
        tooltip: false, //显示缩放百分比
        navbar: false, //显示缩略图导航
        loop: false,
        loading: false

    }
})

Vue.config.productionTip = false

// 全局导航过滤(其实就是拦截路由请求)
// router.beforeEach((to, from, next) => {})

new Vue({
  el: '#app',
  router,
  store,
  md5,
  components: { App },
  template: '<App/>'
})
